import React, { Fragment } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Card, Heading } from '@scentregroup/ui'
import withContentPage from '../../containers/with-content-page'
import Markdown from '../../components/markdown'
import TableOfContents from '../../components/table-of-contents'
import UnifiedHeader from '../../components/unified-header'
import NationalFooter from '../../components/national-footer'
import PageLanding from '../../components/page-landing'
import { MetaData } from '../../../types/meta-data'
import {
  TermsModule,
  MetaData as ContentPageMetaData,
  isTermsModule,
} from '../../../types/content-page'
import titleFromContentPage from '../../helpers/title-from-content-page'
import getCountry from '../../helpers/get-country'
import pagesHoc from '../pages-hoc'
import style from './index.scss'

interface ContentPageProps {
  modules: TermsModule[]
  metaData: ContentPageMetaData
}

const ContentPage: React.FunctionComponent<ContentPageProps> = ({
  metaData,
  modules,
}) => {
  const termsModules = modules.filter(isTermsModule)
  return (
    <Fragment>
      <UnifiedHeader />
      <PageLanding
        heading={metaData.title}
        dataTestId="page-title"
        logo={undefined}
      >
        <Card className={style.card}>
          <TableOfContents sections={termsModules} />
          {termsModules.map(module => (
            <section key={module.slug} className={style.section}>
              <Heading type="large" id={module.slug} className={style.heading}>
                {module.title}
              </Heading>
              <Markdown content={module.bodyCopy} key={module.slug} />
            </section>
          ))}
        </Card>
      </PageLanding>
      <NationalFooter />
    </Fragment>
  )
}

const getMetaData = ({
  metaData,
  staticContext,
}: RouteComponentProps & ContentPageProps): MetaData => {
  const COUNTRY = getCountry(staticContext)
  return {
    title: titleFromContentPage(COUNTRY, metaData),
    description: metaData.shortDescription,
  }
}

export default withContentPage(pagesHoc(ContentPage, getMetaData))
